import { types, actions } from './requests'
export const GETDEPOSITLIST_TYPES = {
    ...types('GETDEPOSITLIST'),
}
export const GETDEPOSITLIST_ACTIONS = {
    ...actions('GETDEPOSITLIST'),
}
